# Login.vue

<template>
  <v-container fluid fill-height>
    <v-row align="center" justify="center" class="ma-0">
      <v-col cols="12" sm="8" md="6" lg="4" class="pa-0">
        <v-card class="mx-4 elevation-2">
          <v-card-text class="text-center pt-8">
            <h1 class="text-h4 font-weight-bold mb-2">
              <span class="primary--text">Software</span>
              <div>Configuration Management</div>
            </h1>

            <div class="text-body-1 grey--text text--darken-1">
              Sign in to start your session
            </div>
          </v-card-text>

          <v-card-text class="pt-4 pb-6">
            <v-btn
                block
                color="primary"
                height="48"
                rounded
                @click="login"
            >
              <v-icon left>mdi-gitlab</v-icon>
              Sign in with GitLab
            </v-btn>

            <v-btn
                v-if="isLocal"
                block
                outlined
                color="secondary"
                height="44"
                rounded
                class="mt-3"
                @click="devLogin"
            >
              <v-icon left>mdi-flask-outline</v-icon>
              Dev Login (local)
            </v-btn>

            <v-alert
                v-if="error"
                type="error"
                class="mt-4 mb-0"
                text
                dense
            >
              {{ error }}
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import api from "@/config/api/users";
import authApi from "@/config/api/oauth";

export default {
  name: 'Login',
  data: () => ({
    oauthLink: process.env.VUE_APP_OAUTH_URL,
    checkInterval: null,
    accessToken: '',
    error: null,
  }),

  computed: {
    isLocal() {
      return process.env.NODE_ENV === 'local';
    }
  },

  created() {
    this._loginWindow = null;
  },

  methods: {
    async devLogin() {
      this.error = null;
      try {
        const { accessToken } = await authApi.devToken({ id: 1, roles: ['USER', 'ADMIN'] });
        document.cookie = `access_token=${accessToken}; path=/`;
        const user = await api.getUserInfo();
        this.$store.commit('setUser', user);
        await this.$router.push('/dashboard');
      } catch (error) {
        console.error('Dev login failed:', error);
        this.error = 'Dev login failed';
      }
    },

    login() {
      const width = 500;
      const height = 700;
      const left = window.screen.width / 2 - width / 2;
      const top = window.screen.height / 2 - height / 2;

      this.error = null;

      this.$store.commit('removeUser')

      this._loginWindow = window.open(
          this.oauthLink,
          'GitLab Login',
          `width=${width},height=${height},left=${left},top=${top}`
      );

      this.checkInterval = setInterval(this.checkLoginStatus, 500);
    },

    checkLoginStatus() {
      try {
        if (this._loginWindow.closed) {
          this.cleanupLoginCheck();
          this.handleLoginCompletion();
          return;
        }

        const token = document.cookie
            .split(';')
            .find(cookie => cookie.trim().startsWith('access_token'));

        this.accessToken = token ? token.split('=')[1] : '';

        if (this.accessToken) {
          this._loginWindow.close();
          this.cleanupLoginCheck();
          this.handleLoginCompletion();
        }
      } catch (error) {
        console.error('Login status check error:', error);
        this.cleanupLoginCheck();
      }
    },

    async handleLoginCompletion() {
      if (this.accessToken) {
        try {
          const user = await api.getUserInfo();
          this.$store.commit("setUser", user);
          await this.$router.push('/dashboard');
        } catch (error) {
          this.$store.commit('removeUser')
          console.error('Error getting user info:', error);
          this.error = 'Failed to get user information';
        }
      }
    },

    cleanupLoginCheck() {
      if (this.checkInterval) {
        clearInterval(this.checkInterval);
        this.checkInterval = null;
      }
    }
  },

  beforeDestroy() {
    this.cleanupLoginCheck();
    if (this._loginWindow && !this._loginWindow.closed) {
      this._loginWindow.close();
    }
  }
}
</script>